// @flow
import React from "react";

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {strings} from "../../../config";
import {CancelRideWrapper} from "./CancelRideStyle";
import CurrentRideOperations from "../../../Store/Ducks/CurrentRide/operations";


const CancelRide = (props) => {
    return (
        <CancelRideWrapper onClick={props.onCancelButtonClick}>
            {strings.cancel_button_text}
        </CancelRideWrapper>
    );

};

const mapStateToProps = (state, props) => {
    return {};
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onCancelButtonClick: CurrentRideOperations.cancelRideOrProposalClick
        },
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(CancelRide);



// WEBPACK FOOTER //
// ./src/Components/TopBar/CancelRide/CancelRide.js